import { html, LitElement, css, unsafeCSS } from 'lit';
import styles from './listCell.scss?inline';

export default class SotbitListCell extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    render() {
        return html`
            <div class="cell-container">
                <slot></slot>
            </div>
        `;
    }
}
